import { makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { FC } from "react";
import { SubscribedStatus } from "../types";

const useStyles = makeStyles((theme) => ({
  confirmed: {
    color: theme.palette.success.main,
  },
  canceled: {
    color: theme.palette.error.main,
  },
  pending: {
    color: theme.palette.warning.main,
  },
  expired: {
    color: theme.palette.info.main,
  },
}));

const SubscribedStatusText: FC<any> = (props) => {
  const classes = useStyles({});
  const subscribed = props.record;
  return (
    <Typography
      variant="body2"
      className={clsx({
        [classes.confirmed]: subscribed.status === SubscribedStatus.active,
        [classes.canceled]: subscribed.status === SubscribedStatus.canceled,
        [classes.pending]: subscribed.status === SubscribedStatus.pending,
        [classes.expired]: subscribed.status === SubscribedStatus.expired,
      })}
    >
      {subscribed.status}
    </Typography>
  );
};

export default SubscribedStatusText;
